import {
	type DefaultPortableTextBlockStyle,
	type PortableTextBlockComponent,
} from '@portabletext/react';
import styles from './blocks.module.scss';
import { isDev } from 'lib/is-dev';
import { Children } from 'react';

export const blocks: Record<
	DefaultPortableTextBlockStyle,
	PortableTextBlockComponent
> = {
	normal: ({ children, value }) => {
		if ((value as any)._resolved !== true && isDev()) {
			const message =
				'Some Portable Text on this page is missing the groq resolver.';
			console.error(message, children, value);
		}
		return <p>{children}</p>;
	},
	h1: ({ children }) => <h1 className={styles.h1}>{children}</h1>,
	h2: ({ children }) => <h2 className={styles.h2}>{children}</h2>,
	h3: ({ children }) => <h3 className={styles.h3}>{children}</h3>,
	h4: ({ children }) => <h4 className={styles.h4}>{children}</h4>,
	h5: ({ children }) => <h5 className={styles.h5}>{children}</h5>,
	h6: ({ children }) => <h6 className={styles.h6}>{children}</h6>,
	// Using an aside instead of a blockquote, semantically it makes way more sense
	// Even if Sanity calls it a 'blockquote"
	blockquote: ({ children }) => {
		const childrenArray = Children.toArray(children);
		const numberOfWords = childrenArray
			.filter((child) => typeof child === 'string') //Only count the characters in the text, not the "symbols" (HTML tags)
			.reduce(
				(accumulator, childNode) =>
					accumulator + childNode?.split(' ')?.length - 1,
				0,
			); //Tally up all the words in the array of strings.
		if (numberOfWords > 40) {
			//For quotes with over 40 words use a unique style
			return (
				<aside className={`${styles.quote} ${styles.pullQuoteLong}`}>
					{children}
				</aside>
			);
		} else {
			return <aside className={styles.pullQuote}>{children}</aside>;
		}
	},
};

export default blocks;
